import * as Yup from 'yup';

export const Address = Yup.object().shape({
  houseNo: Yup.string().required(),
  address01: Yup.string().required(),
  address02: Yup.string(),
  town: Yup.string().required(),
  country: Yup.string().required(),
  postCode: Yup.string().required(),
});

export const EmbbedAddress = {
  houseNo: Yup.string().required(),
  address01: Yup.string().required(),
  address02: Yup.string(),
  town: Yup.string().required(),
  country: Yup.string().required(),
  postCode: Yup.string().required(),
};
